import { getAppData } from "app/getAppData";
import {
  setPuzzelOrgConfig,
  setPuzzelRuntimeConfig,
} from "app/PuzzelAuth/puzzelAuthConfig";
import { Amplify } from "aws-amplify";

let isConfigured = false;

export const configureAuth = async (): Promise<void> => {
  if (isConfigured) {
    return;
  }

  const {
    authUrl,
    clientId,
    userPoolId,
    puzzelClientId,
    puzzelIdpScheme,
    puzzelCiqType,
    puzzelPhoneNumberPrefix,
    puzzelFunctionalNumberPrefix,
    puzzelCountryCode,
    puzzelMaxAttempts,
    puzzelMaxOneRequestForPreferredAgent,
    puzzelPreferredAgentWaitTimeSeconds,
    puzzelQueueKey,
    puzzelReservedAgentWaitTimeSeconds,
    puzzelSecondsBetweenAttempts,
  } = await getAppData();

  setPuzzelRuntimeConfig({
    clientId: puzzelClientId,
    idpScheme: puzzelIdpScheme,
  });

  setPuzzelOrgConfig({
    ciqType: puzzelCiqType,
    phoneNumberPrefix: puzzelPhoneNumberPrefix,
    functionalNumberPrefix: puzzelFunctionalNumberPrefix,
    countryCode: puzzelCountryCode,
    maxAttempts: puzzelMaxAttempts,
    maxOneRequestForPreferredAgent: puzzelMaxOneRequestForPreferredAgent,
    preferredAgentWaitTimeSeconds: puzzelPreferredAgentWaitTimeSeconds,
    queueKey: puzzelQueueKey,
    reservedAgentWaitTimeSeconds: puzzelReservedAgentWaitTimeSeconds,
    secondsBetweenAttempts: puzzelSecondsBetweenAttempts,
  });

  Amplify.configure({
    Auth: {
      Cognito: {
        loginWith: {
          oauth: {
            redirectSignIn: [`${window.location.origin}/login-redirect`],
            redirectSignOut: [`${window.location.origin}`],
            // Domain is set in terraform with https:// at the beginning, must be removed here to avoid double https in the URL
            domain: authUrl.replace("https://", ""),
            scopes: [],
            responseType: "code",
          },
        },
        userPoolId,
        userPoolClientId: clientId,
      },
    },
  });

  isConfigured = true;
};
